import { Button, ButtonGroup, Container, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BrandEnum } from "../_common/enum/brand.enum";
import { FormTemplateTypeEnum } from "../_common/enum/forms/formTemplateType.enum";
import { LoaderDoubleLines } from "../_components/loader/LoaderDoubleLines";
import { quoteTypeOrder } from "../_const/quoteTypeDisplayOrder.const";
import { splitWordOnCamelCase } from "../_helpers/format.helper";
import { withFormAccessToken } from "../_helpers/formAccessToken.helper";
import { handleErrorResponse } from "../_helpers/handleResponse.helper";
import { retryHeight, sendContainerHeightToParent } from "../_helpers/iFrameSize.helper";
import { parentQueryHasExpiredLink } from "../_helpers/parentContext.helper";
import { formService } from "../_services/form.service";

export function isExpiredApplyLink(searchParams: URLSearchParams) {
    return searchParams.get("expired") === "1" || parentQueryHasExpiredLink();
}

export function ExpiredApplyLink(params: { brand: BrandEnum }) {
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        retryHeight(sendContainerHeightToParent);
    }, []);

    function startNewQuote(formTemplateTypeId: FormTemplateTypeEnum) {
        setLoading(true);
        return formService.createByType(formTemplateTypeId, params.brand)
            .then(({ id, token }) => {
                navigate(withFormAccessToken(`/forms/${id}`, id, token));
            }, handleErrorResponse)
            .finally(() => {
                setLoading(false);
                retryHeight(sendContainerHeightToParent);
            });
    }

    return (
        <Container id="formContainer">
            <LoaderDoubleLines loading={isLoading} />
            <ButtonGroup variant="outlined" fullWidth>
                {quoteTypeOrder.map((numericValue) => (
                    <Button
                        key={numericValue}
                        onClick={() => startNewQuote(numericValue)}
                        sx={{ color: "primary.main" }}
                    >
                        {splitWordOnCamelCase(FormTemplateTypeEnum[numericValue])}
                    </Button>
                ))}
            </ButtonGroup>
            <Typography variant="h5" align="center" gutterBottom sx={{ mt: 3 }}>This link has expired</Typography>
            <Typography align="center">For your security, apply links are only valid for 30 days. Please start a new quote to continue.</Typography>
        </Container>
    );
}
